import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import { TicketListResponse, Ticket, TicketConversation, TicketPrivateConversation, TicketStatus, TicketSubtype, TicketGroup, TicketType} from "../http/protocol";


export class TicketService extends AbstractAdminEntityService<Ticket, TicketListResponse>   {
    

    constructor(http : HttpService) {
        super("/tickets", http)
    }

    save(ticket: Ticket): Promise<Ticket> {
        return this.http.post(this.entityPath + `/ticket/`, ticket);
    }

    getTicket(id: string): Promise<Ticket> {
        return this.http.get(this.entityPath + `/ticket/${id}`);
    }

    addTicketConversation(conversation: TicketConversation): Promise<TicketConversation> {
        return this.http.post(this.entityPath + `/conversation`, conversation);
    }

    deleteTicketConversation(ticketId: string, id: string): Promise<TicketConversation> {
        return this.http.delete(this.entityPath + `/conversation/${ticketId}/${id}`);
    }

    addPrivateConversation(conversation: TicketPrivateConversation): Promise<TicketPrivateConversation> {
        return this.http.post(this.entityPath + `/private-conversation`, conversation);
    }

    updateTicket(id: string | undefined, ticket: Ticket): Promise<Ticket> {
        return this.http.put(this.entityPath + `/ticket/${id}`, ticket);
    }

    updateTicketStatus(id: string | undefined, status: TicketStatus): Promise<Ticket> {
        return this.http.put(this.entityPath + `/ticket/${id}/status`, status);
    }

    updateTicketSubtype(id: string | undefined, type: TicketSubtype): Promise<Ticket> {
        return this.http.put(this.entityPath + `/ticket/${id}/subtype`, type);
    }
    
    updateTicketType(id: string | undefined, type: TicketType): Promise<Ticket> {
        return this.http.put(this.entityPath + `/ticket/${id}/type`, type);
    }
    
    updateTicketGroup(id: string | undefined, groups: TicketGroup): Promise<Ticket> {
        return this.http.put(this.entityPath + `/ticket/${id}/groups`, groups);
    }

    getSubtypeByType(type: TicketType): TicketSubtype[] | undefined {
        let result : TicketSubtype[] | undefined = undefined;
        switch(type){
            case TicketType.SPORTSBOOK:
                result = [TicketSubtype.GENERAL_INFORMATION, TicketSubtype.BET_NOT_ACCEPTED, TicketSubtype.GRADING_REQUEST, TicketSubtype.LINE_REQUEST, TicketSubtype.MISGRADES, TicketSubtype.CANCELLATIONS_AND_REFUNDS, TicketSubtype.BAD_LINES, TicketSubtype.GENERAL_QUESTIONS, TicketSubtype.LIMITS_INQUIRY, TicketSubtype.PROMOTIONS, TicketSubtype.TECHNICAL_ISSUES];
                break;
            case TicketType.POKER:
                result = [TicketSubtype.GENERAL_INFORMATION, TicketSubtype.CLIENT_REPORTS, TicketSubtype.POKER_CLAIMS, TicketSubtype.COLLUTION_REPORT, TicketSubtype.GENERAL_QUESTIONS, TicketSubtype.HAND_DISPUTE, TicketSubtype.HAND_INFORMATION, TicketSubtype.RAKE, TicketSubtype.ROLLOVER, TicketSubtype.TECHNICAL_ISSUES];
                break;
            case TicketType.CASINO:
                result = [TicketSubtype.GENERAL_INFORMATION, TicketSubtype.CASINO_CLAIMS, TicketSubtype.FREE_SPINS_AND_BONUS, TicketSubtype.FREE_SPINS_INFORMATION_OR_DISPUTE, TicketSubtype.GAME_DISPUTE, TicketSubtype.GAME_INFORMATION, TicketSubtype.GENERAL_QUESTIONS, TicketSubtype.TECHNICAL_ISSUES];
                break;
            case TicketType.SECURITY:
                result = [TicketSubtype.CANCELLED_WDS_AND_ON_HOLD, TicketSubtype.ACCOUNT_REVIEW, TicketSubtype.CLOSED_ACCOUNT_QUESTIONS, TicketSubtype.IP_LOGIN_REQUIREMENT, TicketSubtype.ONGOING_SECURITY_REVIEWS];
                break;
            case TicketType.CASHIER:
                result = [TicketSubtype.WITHDRAWALS, TicketSubtype.DEPOSITS, TicketSubtype.WITHDRAWAL_ERROR, TicketSubtype.DEPOSIT_ERROR, TicketSubtype.DEPOSIT_CONFIRMATION, TicketSubtype.GENERAL_QUESTIONS, TicketSubtype.MANUAL_DEPOSIT_OR_DUPLICATE_WALLET, TicketSubtype.WITHDRAWAL_QUESTIONS, TicketSubtype.TECHNICAL_ISSUES];
                break;
            case TicketType.BONUS:
                result = [TicketSubtype.RULES, TicketSubtype.ROLLOVER, TicketSubtype.SPECIAL_AND_MANUAL_BONUS, TicketSubtype.NON_DEPOSIT_BONUS, TicketSubtype.REBATES_LOSSBACK, TicketSubtype.CONTESTS, TicketSubtype.BET_CONTRIBUTION, TicketSubtype.BONUS_ABUSE, TicketSubtype.BONUS_PROFILE_UPDATE, TicketSubtype.GENERAL_INFORMATION, TicketSubtype.MANUAL_BONUS, TicketSubtype.POKER_RAKEBACK, TicketSubtype.SPECIAL_CASINO_BONUS, TicketSubtype.SPECIAL_REQUEST, TicketSubtype.VIP, TicketSubtype.TECHNICAL_ISSUES];
                break;
            case TicketType.TECHNICAL_ISSUES:
                result = [TicketSubtype.SPORTSBOOK, TicketSubtype.CASINO, TicketSubtype.POKER, TicketSubtype.BONUS_FUNCTIONALITY, TicketSubtype.MISGRADES, TicketSubtype.CANCELLATIONS_AND_REFUNDS, TicketSubtype.BAD_LINES];
                break;
            case TicketType.ACCOUNT:
                result = [TicketSubtype.PROPERTIES, TicketSubtype.LIMITS, TicketSubtype.SELF_EXCLUSION, TicketSubtype.OWED_FUNDS, TicketSubtype.TWOFA, TicketSubtype.BALANCE, TicketSubtype.CHAT, TicketSubtype.EMAIL, TicketSubtype.GENERAL_QUESTIONS, TicketSubtype.LIGHT_OR_DARK_MODE, TicketSubtype.SITE_PROFILE, TicketSubtype.TICKETS, TicketSubtype.VERIFICATION_CODE, TicketSubtype.CLOSING_ACCOUNT];
                break;
            case TicketType.AFFILIATES:
                result = [TicketSubtype.GENERAL_INFORMATION, TicketSubtype.REFER_TO_AFF_DEPT, TicketSubtype.GENERAL_QUESTIONS, TicketSubtype.PAYMENT]
                break;
            case TicketType.RACEBOOK:
                result = [TicketSubtype.BET_PAYOUTS, TicketSubtype.REBATE, TicketSubtype.GENERAL_QUESTIONS, TicketSubtype.TECHNICAL_ISSUES]
                break;
            case TicketType.SITE:
                result = [TicketSubtype.RULES, TicketSubtype.LOGIN_ISSUES, TicketSubtype.SITE_DOWN, TicketSubtype.GENERAL_QUESTIONS]
                break;
            case TicketType.OTHER:
                result = [TicketSubtype.OTHER]
                break;
        }

        return result;
    }
}
